export function buildStateCityTree(citiesWithCounts = []) {
  const byState = {};
  citiesWithCounts.forEach((item) => {
    const estado = String(item.estado || '').trim() || '(Sem UF)';
    if (!byState[estado]) byState[estado] = [];
    byState[estado].push({ cidade: item.cidade, count: item.count });
  });
  return Object.entries(byState)
    .map(([estado, cities]) => ({
      estado,
      cities: [...cities].sort((a, b) => b.count - a.count),
    }))
    .sort((a, b) => {
      const sumA = a.cities.reduce((acc, c) => acc + c.count, 0);
      const sumB = b.cities.reduce((acc, c) => acc + c.count, 0);
      return sumB - sumA;
    });
}

export function filterStateCityTree(stateTree, searchTerm) {
  if (!searchTerm?.trim()) return stateTree;
  const t = searchTerm.toLowerCase().trim();
  return stateTree
    .map(({ estado, cities }) => {
      const estadoMatch = estado.toLowerCase().includes(t);
      const filteredCities = cities.filter((c) => c.cidade.toLowerCase().includes(t));
      if (estadoMatch) return { estado, cities };
      if (filteredCities.length > 0) return { estado, cities: filteredCities };
      return null;
    })
    .filter(Boolean);
}
